// Account Statement Report

function layout(props) {
  const ctxView = {
    model: "account_statement_co.advanced.start",
    reportName: "account_statement_co.advanced_report",
    fields: {
      operation_center: {
        type: "many2one",
        model: "company.operation_center",
        searchable: true,
        required: true,
        default: props?.operation_center,
      },
      date: {
        type: "date",
        required: true,
        default: props?.date,
      },
    },
    list: [],
    form: [{ name: "date" }],
  };

  if (props?.operationCenter) {
    ctxView.form.unshift({
      name: "operation_center",
    });
  }
  return ctxView;
}

export { layout };
